<template>
    <appWorkshop :is-view="true" />
</template>

<script>
  import appWorkshop from '@/components/user/app/app-workshop';

  export default {
    name: 'view',
    components: {
      appWorkshop,
    },
  };
</script>

<style scoped lang="scss">

</style>
